import { render, staticRenderFns } from "./DownloadAccel.vue?vue&type=template&id=232c0cd8&scoped=true&"
import script from "./DownloadAccel.vue?vue&type=script&lang=js&"
export * from "./DownloadAccel.vue?vue&type=script&lang=js&"
import style0 from "./DownloadAccel.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DownloadAccel.vue?vue&type=style&index=1&id=232c0cd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232c0cd8",
  null
  
)

export default component.exports